// Stable plugin + character identity is mandatory. Wallet binding is optional
// and must never select a different character on a deeplink.
export function resolveCharacterLink(rows, target) {
  const pluginId = String(target?.pluginId || '').trim()
  const characterId = String(target?.characterId || '').trim()
  if (!pluginId || !characterId) return null
  const matches = (Array.isArray(rows) ? rows : []).filter(item =>
    String(item?.plugin_id || '') === pluginId &&
    String(item?.character?.id || '') === characterId,
  )
  const wallet = String(target?.wallet || '').trim()
  return (wallet ? matches.find(item => String(item.wallet_public_key || '') === wallet) : null)
    || matches[0] || null
}
